import React, { FunctionComponent, useState } from 'react'
import { Button, Dropdown, Modal, Text } from '@wework/dieter-ui'
import IMTheme from '../../../style/IMTheme'
import Row from '../../Common/Row'
import _ from 'lodash'

const options = [
  /* eslint-disable prettier/prettier */
  { key: 'PRIVATE_OFFICE',         value: 'PRIVATE_OFFICE',           text: 'Private Office' },
  { key: 'BOOKABLE_PRIVATE_OFFICE',value: 'BOOKABLE_PRIVATE_OFFICE',  text: 'Bookable Private Office' },
  { key: 'COMMON_SPACE',           value: 'COMMON_SPACE',             text: 'Common Space' },
  { key: 'CONFERENCE_ROOM',        value: 'CONFERENCE_ROOM',          text: 'Conference Room' },
  { key: 'DAILY_DESK',             value: 'DAILY_DESK',               text: 'Daily Desk' },
  // { key: 'SHAREABLE_WORKSPACE',    value: 'SHAREABLE_WORKSPACE',      text: 'Shareable Workspace' },
]
/* eslint-enable prettier/prettier */

const caseSensitiveSearch = (options, query) => {
  const re = new RegExp(_.escapeRegExp(query))
  return options.filter(opt => re.test(opt.text))
}

interface CreateProductProps {
  space: any
  trigger: React.ReactNode
  handleLinkProduct: () => void
  handleCreateProduct: (productType) => void
}

const CreateProduct: FunctionComponent<CreateProductProps> = ({
  space,
  trigger,
  handleLinkProduct,
  handleCreateProduct,
}) => {
  const [open, setOpen] = useState(false)
  const [productType, setProductType] = useState<string>()

  return (
    <Modal
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      open={open}
      trigger={trigger}
    >
      <Modal.Header>
        <Text
          style={{
            fontSize: IMTheme.fontSizes[7],
            fontWeight: IMTheme.fontWeights.bold,
          }}
        >
          Create inventory
        </Text>
      </Modal.Header>
      <Modal.Content>
        <Text
          style={{
            fontSize: IMTheme.fontSizes[2],
            fontWeight: IMTheme.fontWeights.normal,
            marginBottom: IMTheme.spacing[4],
          }}
        >
          Select an inventory type for{' '}
          <span style={{ fontWeight: IMTheme.fontWeights.bold }}>
            {space.number} {space.subType}
          </span>{' '}
          to create a new inventory.
        </Text>
        <Text
          style={{
            fontSize: IMTheme.fontSizes[1],
            color: IMTheme.colors.darkGray,
            position: 'absolute',
            backgroundColor: 'white',
            zIndex: 1,
            margin: '-16px 0 0 8px',
            padding: '0 8px 0 8px',
          }}
        >
          Inventory type
        </Text>
        <Dropdown
          fluid
          options={options}
          search={caseSensitiveSearch}
          selection
          onChange={(event, data) => {
            setProductType(data.value as string)
          }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Row justify="space-between">
          <Row justify="flex-start">
            <Button
              basic
              color="blue"
              onClick={() => {
                setOpen(false)
                handleLinkProduct()
              }}
            >
              Link inventory instead
            </Button>
          </Row>
          <Row justify="flex-end">
            <Button
              style={{ marginRight: IMTheme.spacing[4] }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              primary
              disabled={productType === undefined || productType == null}
              color="blue"
              onClick={() => {
                setOpen(false)
                handleCreateProduct(productType)
              }}
            >
              Create
            </Button>
          </Row>
        </Row>
      </Modal.Actions>
    </Modal>
  )
}

export default CreateProduct
